import {MarketingMaterialService} from "./services/MarketingMaterialService";

export class MarketingMaterial{

    constructor(auth){
        this._auth = auth;
    }

    save(marketingMaterialItem){

        let service = new MarketingMaterialService(this._auth);
        return service.save(marketingMaterialItem);
    }

}